import { API_KEY as builderApiKey } from './builder';
import acceptedLocales from './acceptedLocales';

const config = {
  builderApiKey,
  environment: process.env.NODE_ENV,
  acceptedLocales,
};

export default config;
